module.exports = __webpack_public_path__ + "static/media/syl.299736b4.mp3";